import { createContext } from 'react';

/**
 * Success and error for what an action did; info for something the portal
 * did on the person's behalf (moving them to the organization left to them).
 * Warnings belong on the page.
 */
export type ToastSeverity = 'success' | 'error' | 'info';

export interface ToastOptions {
  message: string;
  /** Defaults to success, which is what most actions report. */
  severity?: ToastSeverity;
  /**
   * A test ID for this one message, beside the fixed `toast` on the toast
   * itself, for a message a test must tell apart from the others.
   */
  testId?: string;
}

export interface ToastContextValue {
  /** Shows a message. A second call replaces whatever is on screen. */
  show: (options: ToastOptions) => void;
}

/**
 * Kept in its own file, separate from the provider component.
 *
 * A file that exports both a component and a non-component value breaks Vite's
 * hot reloading, so the split is deliberate rather than tidiness.
 */
export const ToastContext = createContext<ToastContextValue | null>(null);
